import { toast } from "sonner";
import { Gift, Copy } from "lucide-react";

export default function GiftSection({ wedding }) {
  if (!wedding.gift_enabled || (!wedding.gift_message?.trim() && !wedding.gift_iban?.trim())) return null;

  const copyIban = async () => {
    try {
      await navigator.clipboard.writeText(wedding.gift_iban);
      toast.success("IBAN copiato!");
    } catch {
      toast.error("Impossibile copiare l'IBAN");
    }
  };

  return (
    <section className="py-16 sm:py-20 px-6 sm:px-12" data-testid="gift-section">
      <div className="max-w-xl mx-auto text-center border rounded-3xl p-8" style={{ borderColor: "#e3ddd2" }}>
        <Gift size={28} className="mx-auto mb-4" style={{ color: "var(--wed-primary)" }} />
        <p className="eyebrow mb-3">Un pensiero per noi</p>
        {wedding.gift_message?.trim() && <p className="text-neutral-600 leading-relaxed whitespace-pre-line mb-5">{wedding.gift_message}</p>}
        {wedding.gift_iban?.trim() && (
          <button
            type="button"
            onClick={copyIban}
            className="inline-flex items-center gap-2 bg-neutral-50 border rounded-xl px-4 py-2.5 text-sm font-mono hover:bg-neutral-100 transition-colors duration-150"
            style={{ borderColor: "#e3ddd2" }}
            data-testid="gift-iban-copy"
          >
            {wedding.gift_iban} <Copy size={14} className="text-neutral-400" />
          </button>
        )}
      </div>
    </section>
  );
}
